module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0007#lot"
    }
  }, [_vm._v("List of Tables")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0008#loi"
    }
  }, [_vm._v("List of Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0009#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0010#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")]), _vm._v("  /  Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0011#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TWO")]), _vm._v("  /  The Coevolution of Affect toward Presidents and Parties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0012#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THREE")]), _vm._v("  /  Evaluations of Parties and Party Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0013#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FOUR")]), _vm._v("  /  Assessments of Party Competence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0014#ch05"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIVE")]), _vm._v("  /  Cognitive Views of Parties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0015#ch06"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("SIX")]), _vm._v("  /  Party Identification I: Partisan Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0016#ch07"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("SEVEN")]), _vm._v("  /  Party Identification II: Generational Imprinting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0017#ch08"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("EIGHT")]), _vm._v("  /  Elections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0018#ch09"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("NINE")]), _vm._v("  /  Polarized Parties, the 2016 Elections, and the Early Trump Presidency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0019#ch10"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TEN")]), _vm._v("  /  Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0020#app"
    }
  }, [_vm._v("Appendix: Data Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0021#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0022#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chijacobson0023#fn_notes"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-746350d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-jacobson-0006.vue
// module id = 69
// module chunks = 0